import React from 'react'
import './styles/Auswahl.css'
import {Link} from 'react-router-dom'
import {Collapse} from 'react-collapse';
import Credits from './Credits'
import {CSSTransition} from 'react-transition-group'
import { animateScroll } from 'react-scroll'


class Auswahl extends React.Component{

    constructor(props) {
        super(props);

        const {filter} = props

        this.state = {
            showFilter: !( filter.selected.length === 0 || filter.section !== props.section ),
        }

        this.renderSmallProjectList = this.renderSmallProjectList.bind(this)
        this.renderProjectList = this.renderProjectList.bind(this)
        this.toggleFilter = this.toggleFilter.bind(this)
        this.renderFilter = this.renderFilter.bind(this)
        this.setPreviewIndex = this.setPreviewIndex.bind(this)

    }
    componentWillMount() {
        const {section, filter, filterFunctions} = this.props
        if(filter.section !== section){
            filterFunctions.setFilterSection(section)
        }
    }

    componentWillReceiveProps(nextProps) {
        const { section, filterFunctions } = this.props

        if(nextProps.section !== section){
            filterFunctions.setFilterSection(nextProps.section)
            this.setState({
                showFilter: false,
            })
        }
    }
    componentWillUnmount() {
        this.props.storeScrollPosition(window.pageYOffset)
    }

    render(){
        const { media, section } = this.props
        return(
            <main className="Auswahl main with-footer">

                {media==='MOBILE'?
                    <div className="Filter padding border-bottom">
                        <div>
                            <div className=" float-container" onClick={this.toggleFilter}>
                                <h1 className="float-left">{section === 'com'? 'Commissioned': 'Art'} Works</h1>
                                <div className={this.state.showFilter?"button float-right clickable FilterButton active" :"button float-right clickable FilterButton"}>
                                    <i className="icon icon-fw icon-Filter" />
                                </div>
                            </div>
                            { this.renderFilter() }
                        </div>
                    </div>
                :null}

                {media === 'TABLET'?
                    <div className="Filter padding border-bottom border-top">
                        <div className="tablet-push-half">
                            <div className={this.state.showFilter?"button clickable FilterButton active" :"button clickable FilterButton"} onClick={this.toggleFilter}>
                                <i className="icon icon-fw icon-Filter" /> Filter
                            </div>
                            { this.renderFilter() }
                        </div>
                    </div>
                :null}

                {media === 'DESKTOP' ?
                    <div className="Filter padding ">
                        <div className="desktop-push-half">
                            <div className={this.state.showFilter?"button clickable FilterButton active" :"button clickable FilterButton"} onClick={this.toggleFilter}>
                                <i className="icon icon-fw icon-Filter" /> Filter
                            </div>
                            { this.renderFilter() }
                        </div>
                    </div>
                :null}

                {media === 'DESKTOP' ? this.renderProjectList() : this.renderSmallProjectList() }
                <Credits />
            </main>
        )
    }

    renderSmallProjectList(){
        const {content, section, filter} = this.props

        const mappedProjects = content[section].map((p, i, arr)=>{
            const Item = (
                <Link key={p.title} to={section+'/'+p.slug} >
                    <div className="Item padding-vertical grey-type">
                        <div className="row">

                            <div className="col col-6">
                                <div className="ProjectImg fit">
                                    <img className="img-fit block" src={p.vorschaubild.mobileURL} alt={p.vorschaubild.title}/>
                                </div>
                            </div>

                            <div className="col col-6">
                                <div className="ProjectTitle">{p.title}</div>
                                <div className="ProjectCategoire small-type">{p.kategorie}</div>
                            </div>
                        </div>

                    </div>
                        <div className=" margin-horizontal border-bottom" />

                </Link>
            )

            if(filter.selected.length === 0){
                return Item
            }else if(filter.selected.indexOf(p.kategorie)!== -1){
                return Item
            }else{return null}
        })
        return ( <div className="ProjectList">{mappedProjects}</div>)
    }

    renderProjectList(){
        const {content, section, filter} = this.props


        const mappedProjects = content[section].map((p, i, arr)=>{
            let aClass = ''
            if(i === this.state.previewIndex){
                aClass = 'active'
            }
            const Item = (
                <Link key={p.title} to={section+'/'+p.slug} onMouseEnter={()=>this.setPreviewIndex(i)} >

                    <div className={ "ListItem padding-vertical border-bottom " + aClass } >
                        <div className="ProjectTitle">{p.title}</div>
                        <div className="ProjectCategoire small-type">{p.kategorie}</div>
                    </div>

                </Link>
            )

            if(filter.selected.length === 0){
                return Item
            }else if(filter.selected.indexOf(p.kategorie)!== -1){
                return Item
            }else{return null}
        })


        const mappedPreview = content[section].map((p, i, arr)=>{
            let aClass = ''
            if(i === this.state.previewIndex){
                aClass = 'active'
            }
            const Item = (
                <CSSTransition
                    in={(i === this.state.previewIndex)}
                    timeout={350}
                    classNames="fade"
                    mountOnEnter={true}
                    unmountOnExit={true}
                    key={p.title}
                    >

                    <div className={ 'PreviewItem ' + aClass }>
                        <Link to={section+'/'+p.slug} >
                            <img src={p.vorschaubild.mobileURL} alt={p.title} />
                        </Link>
                    </div>

                </CSSTransition>
            )

            if(filter.selected.length === 0){
                return Item
            }else if(filter.selected.indexOf(p.kategorie)!== -1){
                return Item
            }else{return null}
        })

        return (
            <div className="ProjectList padding-horizontal">
                <div className="Preview">
                    <div className="PreviewInner">
                        {mappedPreview}
                    </div>
                </div>
                <div className="desktop-push-half">
                    <div className="border-top" />
                    {mappedProjects}
                </div>
            </div>
        )
    }

    renderFilter(){
        const {filter, section, filterFunctions} = this.props
        const {showFilter} = this.state

        const filterChoices = filter.choices[section].map((c)=>{
            let aClass = ''
            if(filter.selected.indexOf(c)!== -1){
                aClass = ' active'
            }
                return(
                        <div 
                            key={c} 
                            className={"Item clickable small-type " + aClass}
                            onClick={()=>{filterFunctions.setFilterSelect(c)}}
                            >
                            <i className="icon icon-fw icon-Bullet"/>{c}
                        </div>
                    )
            })

        return(
            <Collapse isOpened={showFilter}>
                    <div className="" />
                <div className="Filter  padding-top grey-type">
                    {filterChoices}
                    </div>
            </Collapse>
        )

    }

    toggleFilter(){
        this.setState({showFilter:!this.state.showFilter})
    }

    setPreviewIndex(i){
        this.setState({
            previewIndex: i,
        })
    }

}

export default Auswahl


// WEBPACK FOOTER //
// ./src/Auswahl.js